export const DONE = 'done';
export const NOT_DONE = 'not_done';
export const NONE = 'none';

// export const HABIT_VALUES = [DONE, NOT_DONE, NONE];